/*
 * rheincool — „Häufig zusammen gekauft" (Produktdetail-Handoff §8)
 *
 * Checkboxen aktualisieren Anzahl + Summe live; der Button legt Gerät +
 * gewählte Zubehör-Artikel zusammen in den Warenkorb (keine Bundles —
 * Zubehör bleibt einzeln entfernbar).
 */
class RcFrequentlyBought extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-bought-item]'));
    this.sumEl = this.querySelector('[data-bought-sum]');
    this.labelEl = this.querySelector('[data-bought-label]');
    this.button = this.querySelector('[data-bought-atc]');
    this.errorBox = this.querySelector('[data-bought-error]');

    this.items.forEach((box) => box.addEventListener('change', () => this.update()));
    if (this.button) this.button.addEventListener('click', () => this.addAll());
    this.update();
  }

  formatMoney(cents) {
    const euros = Math.floor(cents / 100);
    const rest = cents % 100;
    const grouped = new Intl.NumberFormat('de-DE').format(euros);
    return rest === 0 ? `${grouped},– €` : `${grouped},${String(rest).padStart(2, '0')} €`;
  }

  update() {
    const chosen = this.items.filter((box) => box.checked);
    let sum = parseInt(this.dataset.basePrice, 10);
    chosen.forEach((box) => {
      sum += parseInt(box.dataset.price, 10);
    });
    if (this.sumEl) this.sumEl.textContent = this.formatMoney(sum);
    if (this.labelEl) {
      this.labelEl.textContent =
        chosen.length === 0
          ? this.labelEl.dataset.deviceOnly || this.labelEl.textContent
          : (this.dataset.labelTemplate || '').replace('[n]', chosen.length);
      if (!this.labelEl.dataset.deviceOnly && chosen.length === 0) {
        this.labelEl.dataset.deviceOnly = this.labelEl.textContent;
      }
    }
  }

  async addAll() {
    const items = [{ id: parseInt(this.dataset.baseVariant, 10), quantity: 1 }];
    this.items
      .filter((box) => box.checked)
      .forEach((box) => items.push({ id: parseInt(box.dataset.variant, 10), quantity: 1 }));

    this.errorBox.hidden = true;
    this.button.disabled = true;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'add_failed');

      if (window.rcTrack) window.rcTrack('add_to_cart', { option: 'nur-geraet', quelle: 'bundle' });
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        bubble.innerHTML = new DOMParser()
          .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
          .body.innerHTML;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && data.sections['cart-drawer']) {
        const inner = new DOMParser()
          .parseFromString(data.sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');
        if (inner) drawer.innerHTML = inner.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
      }
    } catch (error) {
      this.errorBox.textContent = error.message;
      this.errorBox.hidden = false;
    } finally {
      this.button.disabled = false;
    }
  }
}

customElements.define('rc-frequently-bought', RcFrequentlyBought);
